import { EMBED_TYPES } from './constants'

const locations = [
  {
    id: 'straumsundet',
    title: 'Straumsundet',
    src: 'https://svplive-lh.akamaized.net/hls/live/msl5/20001087/vnytt_mLTCtDZlSUPVAuUqmIliz/source.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 60.358455,
    lon: 5.114327,
  },
  {
    id: 'straume',
    title: 'Straume (Rema 1000)',
    src: 'https://svplive-lh.akamaized.net/hls/live/msl5/20001086/vnytt_qSIcaRpL0KZVyWQs6G9CW/source.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 60.360576,
    lon: 5.124039,
  },
    {
    id: 'straume-2',
    title: 'Straume (Obs)',
    src: 'https://svplive-lh.akamaized.net/hls/live/msl5/20001085/vnytt_qy2WDmHr5pgQxjMuWTbDy/source.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 60.360576,
    lon: 5.124039,
  },
  {
    id: 'sotrabrua-ost',
    title: 'Sotrabrua (East)',
    src: 'https://svplive-lh.akamaized.net/hls/live/msl5/20001088/vnytt_0K3lxIhudMtz1yAfOAnk0/source.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 60.372490,
    lon: 5.170646
  },
  {
    id: 'sotrabrua-vest',
    title: 'Sotrabrua (West)',
    src: 'https://kamera.vegvesen.no/public/1229038_2/manifest.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 60.372551,
    lon: 5.161009
  },
  {
    id: 'janaflaten',
    title: 'Janaflaten',
    src: 'https://svplive-lh.akamaized.net/hls/live/msl5/20001088/vnytt_Nhm66VX22NbQJ59NqYyr9/source.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 60.372551,
    lon: 5.161009
  },
  {
    id: 'e16-indre-arna',
    title: 'E16 Indre Arna',
    src: 'https://kamera.vegvesen.no/public/1229030_1/hls_1_stream_1_orig.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 60.417086,
    lon: 5.474415
  },
  {
    id: 'nygardstangen',
    title: 'Nygårdstangen',
    src: 'https://stream1.vossaskyen.no/bt/Nygardstangen.stream/playlist.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 60.384074,
    lon: 5.335443
  },
  {
    id: 'danmarksplass',
    title: 'Danmarksplass',
    src: 'https://stream1.vossaskyen.no/bt/Danmarksplass.stream/playlist.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 60.376530,
    lon: 5.338582
  },
  {
    id: 'aasanevegen',
    title: 'Åsanevegen',
    src: 'https://stream1.vossaskyen.no/bt/Aasanevegen.stream/playlist.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 60.418810,
    lon: 5.311958
  },
  {
    id: 'puddefjordsbroen',
    title: 'Puddefjordsbroen',
    src: 'https://stream1.vossaskyen.no/bt/Puddefjordsbroen.stream/playlist.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 60.383789,
    lon: 5.316943
  },
  {
    id: 'fanaveien',
    title: 'Fanaveien',
    src: 'https://stream1.vossaskyen.no/bt/Fanaveien.stream/playlist.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 60.308196,
    lon: 5.341326
  },
  {
    id: 'bildoy',
    title: 'Bildøy',
    src: 'https://svplive-lh.akamaized.net/hls/live/msl5/20001085/vnytt_c25x3aHGCCyXjA5YsgM1z/source.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 0,
    lon: 0
  },
  {
    id: 'knappskog',
    title: 'Knappskog',
    src: 'https://kamera.vegvesen.no/public/3001079_1/hls_1_stream_1_orig.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 0,
    lon: 0
  },
  {
    id: 'fjosangerveien-bkk',
    title: 'Fjøsangerveien v/BKK',
    src: 'https://kamera.vegvesen.no/public/3000061_1/hls_1_stream_1_orig.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 0,
    lon: 0
  },
  {
    id: 'fjosangerveien-e39',
    title: 'E39 Fjøsangerveien',
    src: 'https://kamera.vegvesen.no/public/1229029_2/hls_1_stream_1_orig.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 0,
    lon: 0
  },
  {
    id: 'vaagbotn-e39',
    title: 'E39 Vågbotn',
    src: 'https://kamera.vegvesen.no/public/1229013_1/hls_1_stream_1_orig.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 0,
    lon: 0
  },
  {
    id: 'stusshamn',
    title: 'Stusshamn',
    src: 'https://svplive-lh.akamaized.net/hls/live/msl5/20001089/avavis_qArI4NNhDh0EqZgMVxUDO/source.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 0,
    lon: 0,
  },
  {
    id: 'kleppesto',
    title: 'Kleppestø retning Holmedalen',
    src: 'https://svplive-lh.akamaized.net/hls/live/msl5/20001088/avavis_mpoykibCSTTtTvs0dargy/source.m3u8',
    type: EMBED_TYPES.VIDEO_JS,
    lat: 0,
    lon: 0
  }
]

locations.sort((a, b) => a.id.localeCompare(b.id, 'no'))

export default locations
